import { render } from "./PriceInfoHeader.vue?vue&type=template&id=65a873b9"
import script from "./PriceInfoHeader.vue?vue&type=script&lang=js"
export * from "./PriceInfoHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__